import { useDispatch, useSelector } from 'react-redux';
import { setSelectedCertInfo, showProgress } from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { ErrorToast } from '../../utils/Utils';
// import useCertificateStat from './useCertificateStat';

const useSelectedCertInfo = () => {
  const dispatch = useDispatch();
  // const fetchSelectedCertStat = useCertificateStat();
  const selectedCert = useSelector((state) => state.certificateData.selectedCert);
  const fetchSelectedCertInfo = async () => {
    if (!selectedCert?.id) return;

    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.CERT_CERT_INFO.replace('ID', selectedCert?.id));
      dispatch(setSelectedCertInfo(res));
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
      // fetchSelectedCertStat();
    }
  };

  return fetchSelectedCertInfo;
};

export default useSelectedCertInfo;
